// External libraries
import React from 'react';
import { useStoreState } from '@/store';
import {
  FloatingLabelSelect,
  // @ts-expect-error TODO this was working pre typescript
} from '@checkout/react-components';

// Internal modules
import { features, getContent, getLocale } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { LoadingElement } from '@/components/Common';

export type PlaceOfBirthProps = {
  blurHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
  changeHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
};

const PlaceOfBirth = (props: PlaceOfBirthProps): JSX.Element => {
  useMountLogging('PlaceOfBirth');
  const placeOfBirth = useStoreState(({ form }) => form.placeOfBirth);
  const selectOptions = useStoreState(({ api }) => {
    const { locale } = getLocale();
    return api.griffinMetadata.territories[locale];
  });
  const theme = features.get('rebrandFormFieldsTheme');

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      id="placeOfBirth"
      label={getContent('fieldLabels.placeOfBirth')}
      name="placeOfBirth"
      required={true}
      selectOptions={selectOptions}
      theme={theme}
      {...placeOfBirth}
      {...props}
    />
  );
};

export { PlaceOfBirth };
